import { UserFriendlyError } from './user-friendly-error'

/**
 * Enables type-checking that is not affected by having multiple versions of
 * this library installed
 */
// The string here is used as the type description for the type checker
const MARKER_SYMBOL = Symbol.for('@attain-apps/UnexpectedError')

/**
 * Something unexpected happened. We should not reveal any details to the end
 * user as such details could contain sensitive information or be used to
 * exploit the system
 */
export class UnexpectedError extends UserFriendlyError {
  // NOTE: must be all upper case to avoid naming collision with the class name
  public static override readonly NAME: string = 'UnexpectedError'
  public override readonly name: string = UnexpectedError.NAME

  // Used by TypeChecker
  private readonly [MARKER_SYMBOL] = true as const

  constructor(actualError?: Error) {
    super('Encountered unexpected error', actualError)
  }
}
export namespace UnexpectedError {
  // NOTE: not using @attain-apps/type-guards as that would introduce circular imports
  export function isUnexpectedError(val: unknown): val is UnexpectedError {
    return !!(val as UnexpectedError)?.[MARKER_SYMBOL]
  }
}
